import { render, staticRenderFns } from "./TrackSideBar.vue?vue&type=template&id=5517a820&scoped=true&lang=pug"
import script from "./TrackSideBar.vue?vue&type=script&lang=js"
export * from "./TrackSideBar.vue?vue&type=script&lang=js"
import style0 from "./TrackSideBar.vue?vue&type=style&index=0&id=5517a820&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5517a820",
  null
  
)

export default component.exports